import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapeProvidedInterface extends Shape {
    width = 200;
    height = 150;

    needFill = false;
    includeText = false;

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        const rw = w * 0.36;
        const rh = h * 0.5;

        canv.ctx.moveTo(x, y + h / 2);
        canv.ctx.lineTo(x + w * 0.28, y + h / 2);

        canv.ctx.moveTo(x + w * 0.28 + rw * 2, y + h / 2);
        canv.ctx.ellipse(x + w * 0.28 + rw, y + h / 2, rw, rh, 0, 0, Math.PI * 2);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M7.738 12c0 4.142 3.193 7.5 7.131 7.5S22 16.142 22 12c0-4.142-3.193-7.5-7.13-7.5-3.94 0-7.132 3.358-7.132 7.5Zm0 0H2"/>
            </svg>
        `;
    }
}
